import type { ThemeWithoutTokens } from '../theme.types';

export const formLabelTokens = (theme: ThemeWithoutTokens) =>
  ({
    formLabelLetterSpacing: theme.typography.letterSpacing.m,
    formLabelTextColor: theme.colors.body.text,
    formLabelBackgroundColor: theme.colors.body.background,
    formLabelFontFamily: theme.typography.fontFamily.regular,
    formLabelFontSize: theme.typography.fontSize.s,
    formLabelLineHeight: theme.typography.lineHeight.s,
    formLabelFontWeight: theme.typography.fontWeight.semibold,
    formLabelRequiredIndicatorColor: theme.colors.danger.normal,
  }) as const;
